import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainLayout from "./layout/MainLayout";
import AuthLayout from "./layout/AuthLayout";
import LoadingSpinner from "./components/UI/loadingSpinner/LoadingSpinner";
import "./scss/App.scss";
import Shops from "./pages/shops/Shops";
import EmployeeDetail from "./pages/employee/EmployeeDetail";
import DistributorDetail from "./pages/distributor/DistributorDetail";
import ReporterDetail from "./pages/reporter/ReporterDetail";
import ShopForm from "./pages/shops/shop-form/ShopForm";
import EmployeeForm from "./pages/employee/employee-form/EmployeeForm";
import DistributorForm from "./pages/distributor/distributor-form/DistributorForm";
import ProductForm from "./pages/product/product-form/ProductForm";
import TripDetail from "./pages/trip/TripDetail";
import Attendances from "./pages/attendances/Attendances";
import ShopDetail from "./pages/shops/ShopDetail";
import Services from "./pages/services/Services";
import Notification from "./pages/services/notification/Notification";
import WorkDetails from "./pages/reports/WorkDetail";
import TimeDetails from "./pages/reports/TimeDetail";
import PartyDetail from "./pages/reports/PartyDetail";
import BeatDetail from "./pages/beat/BeatDetail";
import BeatForm from "./pages/beat/beat-form/BeatForm";
import SaleDetail from "./pages/sale/SaleDetail";
import { ToastContainer } from 'react-toastify';


const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const Employees = React.lazy(() => import("./pages/employee/Employees"));
const Products = React.lazy(() => import("./pages/product/Products"));
const Distributors = React.lazy(() => import("./pages/distributor/Distributors"));
const Sales = React.lazy(() => import("./pages/sale/Sales"));
const Trips = React.lazy(() => import("./pages/trip/Trips"));
const ProductEdit = React.lazy(() => import("./pages/ProductEdit"));
const NotFound = React.lazy(() => import("./pages/NotFound"));
const BlankPage = React.lazy(() => import("./pages/BlankPage"));
const Login = React.lazy(() => import("./pages/Login"));
const EmployeeSales = React.lazy(() => import("./pages/sale/EmployeeSales"));
const DistributorSales = React.lazy(() => import("./pages/sale/DistributorSales"));
const ShopMaps = React.lazy(() => import("./pages/shops/ShopMaps"));
const Reports = React.lazy(() => import("./pages/reports/Reports"));
const Beats = React.lazy(() => import("./pages/beat/Beat"));
function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route element={<AuthLayout />}>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Dashboard />} />
              {/* employee routes */}
              <Route path="/employees" element={<Employees />} />
              <Route path="/employees/edit/:empId" element={<EmployeeForm />} />
              <Route path="/employees/:empId" element={<EmployeeDetail />} />
              <Route path="/employees/add" element={<EmployeeForm />} />
              <Route path="/reporter/:reporterId" element={<ReporterDetail />} />
              {/* product routes */}
              <Route path="/products" element={<Products />} />
              <Route path="/products/add" element={<ProductForm />} />
              <Route path="/products/edit/:id" element={<ProductForm />} />
              {/* distributor routes */}
              <Route path="/distributors" element={<Distributors />} />
              <Route path="/distributors/add" element={<DistributorForm />} />
              <Route path="/distributors/edit/:id" element={<DistributorForm />} />
              <Route path="/distributors/:distributorId" element={<DistributorDetail />} />
              {/* sales routes */}
              <Route path="/sales" element={<Sales />} />
              <Route path="/sales/:id" element={<SaleDetail />} />
              <Route path="/sales/employees" element={<EmployeeSales />} />
              <Route path="/sales/distributors" element={<DistributorSales />} />
              <Route path="/analytics" element={<BlankPage />} />
              {/* shop routes */}
              <Route path="/shops" element={<Shops />} />
              <Route path="/shops/:id" element={<ShopDetail />} />
              <Route path="/shops/add" element={<ShopForm />} />
              <Route path="/shops/edit/:id" element={<ShopForm />} />
              <Route path="/shops/map" element={<ShopMaps />} />
              {/* trip routes */}
              <Route path="/trips" element={<Trips />} />
              <Route path="/trips/:id" element={<TripDetail />} />
              <Route path="/attendances" element={<Attendances />} />
              <Route path="/services" element={<Services />} />
              {/* reports routes */}
              <Route path="/reports" element={<Reports />} /> 
              <Route path="/reports/attendance/:id/work-detail" element={<WorkDetails />} />
              <Route path="/reports/party/:id/party-detail" element={<PartyDetail />} />
              <Route path="/reports/attendance/:id/time-detail" element={<TimeDetails />} />
              <Route path="/services/notification" element={<Notification />} />
              {/* Beat Routes */}
              <Route path="/beats" element={<Beats />} />
              <Route path="/beats/:id" element={<BeatDetail />} />
              <Route path="/beats/form" element={<BeatForm />} />
            </Route>
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ToastContainer />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
